import $ from "jquery";
import {getUserToken} from "@/utils/Cookie";

import store from "@/store/index";


function request(url, method = "POST", options = {}) {
	// 将参数转化成json对象
	var data = JSON.parse(JSON.stringify(options || {}));
	// 没有参数时data处理
	data = data || {};
	var URL = ""
	return new Promise(function (resolve, reject) {
		if (url == 'payments/fupay/getinfobymtoken') {
			// eslint-disable-next-line no-mixed-spaces-and-tabs
			URL = store.state.baseURL;
		} else if (url == 'storemarketing/Selfpurchase/orderQrcodeSelfpurchase') {
			URL = store.state.testURL;
		}
		$.ajax({
			url: URL + url,
			method: method,
			data: data,
			beforeSend: function (XMLHttpRequest) {
				let token = getUserToken();
				if (url == 'storemarketing/Selfpurchase/orderQrcodeSelfpurchase') {
					token = sessionStorage.getItem("payToken")
				}
				if (token) {
					XMLHttpRequest.setRequestHeader("token", token);
				}
			},
			success: function (res) {
				resolve(res);
			},
			error: function (err) {
				reject(err);
			},
		});
	});
}

export default request;

